export default "<!--\n<div [chart]=\"chart\"  id=\"container\"></div>\n\n<div id=\"container1\"></div>\n-->\n";